import emailjs from "@emailjs/browser";
import { MDBCheckbox } from "mdb-react-ui-kit";
import { RefObject, useEffect, useRef, useState } from "react";
import { Reveal } from "react-awesome-reveal";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

import Popup from "reactjs-popup";

import Footer from "../../../components/footer/Footer";
import Gallery from "../../../components/gallery/gallery";
import PcServiceGallery from "../../../components/gallery/pc_services_gallery";
import ServiceGallery from "../../../components/gallery/services_gallery";
import Header from "../../../components/header/header";
import ReviewGallery from "../../../components/reviews/ReviewGallery";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faChevronRight,
  faClose,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

import { keyframes } from "@emotion/react";

import PcGallery from "../../../components/gallery/pc_gallery";
import ReviewGalleryDesktop from "../../../components/reviews/ReviewGalleryDesktop";
import "../../../components/service_template/styles/services_styles.css";

const pavelGallery = require("../../../assets/pavel_gallery.webp");
const pavelGalleryPc = require("../../../assets/pavel_pc.webp");
const modalImage = require("../../../assets/example_modal.webp");

const mainService = require("../../../assets/service_pc.webp");

const doctorOnePc = require("../../../assets/1.webp");
const doctorTwoPc = require("../../../assets/karen_pc.webp");
const doctorThreePc = require("../../../assets/3.webp");
const doctorFourPc = require("../../../assets/islam_pc.webp");
const doctorFivePc = require("../../../assets/elena_pc.webp");
const doctorSixPc = require("../../../assets/tatyana_pc.webp");
const doctorSevenPc = require("../../../assets/marina_pc.webp");
const doctorEightPc = require("../../../assets/karen_pc.webp");
const doctorNinePc = require("../../../assets/karen_pc.webp");
const doctorTenPc = require("../../../assets/orthoped_mob.webp");
const doctorElevenPc = require("../../../assets/sadiga.webp");

const doctorOneMob = require("../../../assets/01.webp");
const doctorTwoMob = require("../../../assets/marina_mob.webp");
const doctorThreeMob = require("../../../assets/03.webp");
const doctorFourMob = require("../../../assets/islam_mob.webp");
const doctorFiveMob = require("../../../assets/elena_mob.webp");
const doctorSixMob = require("../../../assets/tatyana_mob.webp");
const doctorSevenMob = require("../../../assets/marina_mob.webp");
const doctorEightMob = require("../../../assets/karen_mob.webp");
const doctorNineMob = require("../../../assets/marina_mob.webp");
const doctorTenMob = require("../../../assets/orthoped_mob.webp");
const doctorElevenMob = require("../../../assets/marina_mob.webp");

const serviceOnePc = require("../../../assets/service_1.webp");
const serviceTwoPc = require("../../../assets/service_2.webp");
const ServiceThreePc = require("../../../assets/service_3.webp");
const ServiceFourPc = require("../../../assets/service_4.webp");

const serviceOneMob = require("../../../assets/service_mob_01.webp");
const serviceTwoMob = require("../../../assets/service_mob_02.webp");
const serviceThreeMob = require("../../../assets/service_mob_03.webp");
const serviceFourMob = require("../../../assets/service_mob_04.webp");

const hygienePc = require("../../../assets/teeth-in-sleep.webp");

const logoMobile: string = require("../../../assets/logo_mob.svg").default;

const TeethCt = () => {
  const [thankYou, setThankYou] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMenuPcOpen, setIsMenuPcOpen] = useState(false);

  const customAnimation = keyframes`
  from {
    opacity: 1;
    transform: translate3d(0px, 0px, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(-2000, 0, 0);
  }
`;

  const [open, setOpen] = useState(false);

  const phoneForm = useRef<HTMLFormElement>(null);

  function openPopupWindow() {
    setOpen(true);
  }

  function sendPhoneRequest(e: any) {
    e.preventDefault();
    setFullName("");
    setPhoneNumber("");

    emailjs
      .sendForm(
        "service_kwh5orp",
        "template_rgnaux5",
        e.target,
        "b-K7bdT7JW4cqcN4y"
      )
      .then((res) => {
        setThankYou(true);
        console.log("SUCCESS");
      })
      .catch((err) => console.log(err));
  }

  const openModal = () => {
    console.log("Opening modal");
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setThankYou(false);
  };

  const [isLoading, setIsLoading] = useState(true);

  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [comment, setComment] = useState("");

  const form: RefObject<HTMLDivElement> = useRef(null);

  function sendEmail(e: any) {
    e.preventDefault();
    setFullName("");
    setPhoneNumber("");
    setServiceName("");
    setDoctorName("");
    setServiceName("");

    emailjs
      .sendForm(
        "service_kwh5orp",
        "template_5kdc5wu",
        e.target,
        "b-K7bdT7JW4cqcN4y"
      )
      .then((res) => {
        setThankYou(true);
        console.log("SUCCESS");
      })
      .catch((err) => console.log(err));
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const togglePcMenu = () => {
    setIsMenuPcOpen(!isMenuPcOpen);
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => {};
  }, []);

  return (
    <div className="div">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Компьютерная томография зубов и челюстей в Ивантеевке</title>
        <meta
          property="og:title"
          content="Компьютерная томография зубов и челюстей в Ивантеевке"
        ></meta>
        <meta
          property="og:description"
          content=" Профессиональная КТ диагностика зубов и челюстей в Ивантеевке. Высокоточные результаты и безопасность процедуры. Записывайтесь на КТ у нас!"
        ></meta>
        <meta
          name="description"
          content=" Профессиональная КТ диагностика зубов и челюстей в Ивантеевке. Высокоточные результаты и безопасность процедуры. Записывайтесь на КТ у нас!"
        ></meta>
      </Helmet>
      {isLoading ? (
        <Reveal keyframes={customAnimation} delay={1000}>
          <div className={`loader ${isLoading ? "" : "hidden"}`}>
            <div className="loader-container">
              <img className="logo" src={logoMobile} alt="logo"></img>
              <h1 className="loading-heading">
                Клиника Эстетической Стоматологии
              </h1>
            </div>
          </div>
        </Reveal>
      ) : (
        <div className="screen">
          <Helmet>
            <meta charSet="utf-8" />
            <title>Компьютерная томография зубов и челюстей в Ивантеевке</title>
            <meta
              property="og:title"
              content="Компьютерная томография зубов и челюстей в Ивантеевке"
            ></meta>
            <meta
              property="og:description"
              content=" Профессиональная КТ диагностика зубов и челюстей в Ивантеевке. Высокоточные результаты и безопасность процедуры. Записывайтесь на КТ у нас!"
            ></meta>
            <meta
              property="og:description"
              content=" Профессиональная КТ диагностика зубов и челюстей в Ивантеевке. Высокоточные результаты и безопасность процедуры. Записывайтесь на КТ у нас!"
            ></meta>
          </Helmet>
          <main className="services-screen-mobile">
            <div className="content">
              <div className="header-container" style={{ width: "100%" }}>
                <Header
                  isMenuOpen={isMenuOpen}
                  toggleMenu={toggleMenu}
                  openModal={openModal}
                ></Header>
              </div>
              <div className="tablet" style={{ width: "100%" }}>
                <Header
                  isMenuPcOpen={isMenuPcOpen}
                  togglePcMenu={togglePcMenu}
                  openModal={openModal}
                ></Header>
              </div>
              <div className="heading-container">
                <div className="bread-dots">
                  <Link to="/" className="link">
                    Главная
                  </Link>
                  <div className="circle"></div>
                  <Link to="/#services" className="link">
                    Услуги
                  </Link>
                  <div className="circle"></div>
                  <Link to="/services/teeth-ct" className="link active">
                    Компьютерная томография (КТ) зубов
                  </Link>
                </div>
                <h1 className="heading">
                  Компьютерная томография (КТ) зубов в Ивантеевке
                </h1>
                <button className="golden-button" onClick={openModal}>
                  <span className="text">Записаться</span>
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="icon"
                  ></FontAwesomeIcon>
                </button>
              </div>
              <div className="information-container">
                <div className="divider-container">
                  <div className="divider"></div>
                  <span className="text">Об услуге</span>
                </div>
                <section className="information">
                  <h3 className="information-heading">
                    Компьютерная томография зубов и челюсти в Ивантеевке:
                    точность и безопасность
                  </h3>
                  <p className="information-paragraph">
                    Если вы задаетесь вопросом, как получить максимально точное
                    представление о состоянии своих зубов и челюсти, то
                    компьютерная томография (КТ) - это то, что вам нужно. В
                    стоматологии Dental Home мы предлагаем 3D компьютерную
                    томографию зубов, которая позволяет получить высокоточный
                    снимок полости рта.
                    <br /> <br />
                    КТ зубов - это современный метод диагностики, который
                    позволяет получить более подробную информацию, чем рентген.
                    Благодаря КТ, стоматолог может увидеть не только зубы, но и
                    кости, мягкие ткани и нервы. Это помогает более точно
                    определить причину болезней зубов и челюсти и выбрать
                    наиболее эффективное лечение.
                    <br />
                    <br />
                    Сделать КТ зубов в Ивантеевке можно в стоматологии Dental
                    Home. Наши специалисты используют современное оборудование,
                    которое обеспечивает высокую точность и безопасность
                    процедуры.
                  </p>
                  <div className="divider"></div>
                  <h3 className="information-heading">
                    Как проходит КТ зубов?
                  </h3>
                  <p className="information-paragraph">
                    Компьютерная томография зубов - это безболезненная
                    процедура, которая занимает всего несколько минут. Во время
                    КТ пациенту необходимо находиться в специальном аппарате,
                    который делает серию рентгеновских снимков. После этого
                    компьютер обрабатывает полученные данные и создает 3D модель
                    полости рта.
                    <br /> <br />
                    КТ зубов - это современный метод диагностики, который
                    позволяет получить более подробную информацию, чем рентген.
                    Благодаря КТ, стоматолог может увидеть не только зубы, но и
                    кости, мягкие ткани и нервы. Это помогает более точно
                    определить причину болезней зубов и челюсти и выбрать
                    наиболее эффективное лечение.
                    <br />
                    <br />
                    КТ зубов - это безопасная процедура, которая не требует
                    особых подготовительных мер. Однако, если вы беременны или
                    подозреваете, что можете быть беременны, обязательно
                    сообщите об этом своему врачу перед процедурой.
                  </p>
                  <div className="divider"></div>

                  <h3 className="information-heading">
                    Для чего нужна КТ зубов?
                  </h3>
                  <p className="information-paragraph">
                    Компьютерная томография зубов может использоваться для {""}
                    {""} {""}
                    <a href="https://dental-home.ru/services/diagnostic">
                      {" "}
                      {""}
                      {""}
                      диагностики различных заболеваний и состояний полости рта{" "}
                      {""}
                    </a>
                    {""}
                    , таких как:
                    <br />
                    <br />
                    - кариес;
                    <br />
                    <br />
                    - периодонтит;
                    <br />
                    <br />
                    - кисты;
                    <br />
                    <br />
                    - опухоли;
                    <br />
                    <br />
                    - травмы.
                    <br />
                    <br />
                    КТ зубов также может использоваться для планирования
                    имплантации зубов и других хирургических процедур.
                  </p>
                  <div className="divider"></div>

                  <h3 className="information-heading">
                    Записаться на КТ зубов в Ивантеевке
                  </h3>
                  <p className="information-paragraph">
                    Если вы хотите сделать КТ зубов в Ивантеевке, то записаться
                    на прием в стоматологию Dental Home можно по телефону или
                    через онлайн-форму на нашем сайте. Наши специалисты помогут
                    вам подготовиться к процедуре и ответят на все ваши вопросы.
                    <br /> <br />
                    Компьютерная томография зубов - это современный и безопасный
                    метод диагностики, который позволяет получить максимально
                    точное представление о состоянии зубов и челюсти. Сделать КТ
                    зубов в Ивантеевке можно в стоматологии Dental Home, где вы
                    получите высококачественное лечение и заботливое отношение.
                  </p>
                </section>
              </div>
              <div className="services-gallery">
                <h4 className="heading">Работы</h4>
                <div className="divider"></div>
                <ServiceGallery
                  imageSrc={serviceOneMob}
                  imageSrcTwo={serviceTwoMob}
                  imageSrcThree={serviceOneMob}
                  imageSrcFour={serviceFourMob}
                />
              </div>
              <div className="services-gallery">
                <h4 className="heading">Наши специалисты</h4>
                <div className="divider"></div>
                <Gallery openModal={openModal} />
              </div>
              <div className="services-gallery">
                <h4 className="heading">Отзывы</h4>
                <div className="divider"></div>
                <ReviewGallery></ReviewGallery>
                <div className="form-screen" id="form-screen-mob">
                  <section className="content">
                    <div className="form-heading-container">
                      <h3 className="form-heading">Записаться На Прием</h3>
                    </div>
                    <div className="divider"></div>
                    <form action="" className="form">
                      <div className="input-container">
                        <label htmlFor="name" className="la">
                          Имя*
                        </label>
                        <input
                          type="text"
                          required={true}
                          value={fullName}
                          name="fullName"
                          onChange={(event) => setFullName(event.target.value)}
                          className="input-text"
                          placeholder="Иван Иванов"
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phone" className="la">
                          Номер телефона*
                        </label>
                        <input
                          type="tel"
                          value={phoneNumber}
                          onChange={(event) =>
                            setPhoneNumber(event.target.value)
                          }
                          name="phoneNumber"
                          className="input-text"
                          placeholder="+7 (925) 222-90-22"
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="service" className="la">
                          Услуга
                        </label>
                        <input
                          type="text"
                          value={serviceName}
                          onChange={(event) =>
                            setServiceName(event.target.value)
                          }
                          name="serviceName"
                          placeholder="Выберите Услугу"
                          className="input-text"
                        />
                      </div>
                      {/* <div className="input-container">
                  <label htmlFor="direction" className="la">
                    Направление
                  </label>
                  <input
                    type="text"
                    name="direction"
                    placeholder="Выберите Направление"
                    className="input-text"
                  />
                </div> */}
                      <div className="input-container">
                        <label htmlFor="doctor" className="la">
                          Врач
                        </label>
                        <input
                          type="text"
                          name="doctorName"
                          value={doctorName}
                          onChange={(event) =>
                            setDoctorName(event.target.value)
                          }
                          placeholder="Выберите Врача"
                          className="input-text"
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="comment" className="la">
                          Комментарий
                        </label>
                        <textarea
                          name="comment"
                          value={comment}
                          onChange={(event) => setComment(event.target.value)}
                          className="comment"
                        ></textarea>
                      </div>
                      <div className="checkbox-container">
                        <div className="checkbox-container-2">
                          <MDBCheckbox
                            name="flexCheck"
                            value=""
                            id="flexCheckChecked"
                            label="Ознакомлен с Условиями обработки персональных данных"
                            defaultChecked
                          />
                        </div>
                      </div>
                      <button className="form-button" onClick={sendEmail}>
                        Записаться на прием
                        <FontAwesomeIcon
                          className="icon"
                          icon={faChevronRight}
                          style={{
                            fontSize: "clamp(7px,3.2709599999999996vw,28px",
                            marginLeft: "clamp(4px,1.86912vw,16px)",
                          }}
                        ></FontAwesomeIcon>
                      </button>
                    </form>
                  </section>
                </div>
              </div>
            </div>
          </main>
          <main className="services-pc">
            <div className="pc-content">
              <Header
                isMenuPcOpen={isMenuPcOpen}
                togglePcMenu={togglePcMenu}
                openModal={openModal}
              ></Header>
              <div className="upper-content">
                <div className="heading-container">
                  <div className="bread-dots-container">
                    <Link to="/" className="link">
                      Главная
                    </Link>
                    <div className="circle"></div>
                    <Link to="/#services" className="link">
                      Услуги
                    </Link>
                    <div className="circle"></div>
                    <Link to="/services/teeth-pc" className="link active">
                      Компьютерная томография (КТ) зубов
                    </Link>
                  </div>
                  <h1 className="heading" style={{ width: "30%" }}>
                    Компьютерная томография (КТ) зубов в Ивантеевке
                  </h1>
                  <button className="button" onClick={openModal}>
                    <span className="text">Записаться</span>
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className="icon"
                    ></FontAwesomeIcon>
                  </button>
                </div>
                <img
                  src={hygienePc}
                  alt="service"
                  className="service-image"
                ></img>
              </div>
              <div className="services-content">
                <div className="services-list">
                  <span className="text">Содержание</span>
                  <div className="buttons">
                    <ScrollLink
                      to="information"
                      className="button"
                      style={{ width: "110%" }}
                    >
                      Основная информация
                    </ScrollLink>
                    <ScrollLink to="doctors" className="button">
                      Врачи
                    </ScrollLink>
                    <ScrollLink to="prices" className="button">
                      Цена
                    </ScrollLink>
                    <ScrollLink to="works" className="button">
                      Работы
                    </ScrollLink>
                    <ScrollLink to="reviews" className="button">
                      Отзывы
                    </ScrollLink>
                    <ScrollLink
                      to="form-screen"
                      value={"Записаться на прием"}
                      className="button"
                    >
                      Записаться на прием
                    </ScrollLink>
                  </div>
                </div>
                <div className="services-information" id="information">
                  <span className="text">Об услуге</span>
                  <div className="information-one">
                    <h3 className="heading-info">
                      Компьютерная томография зубов и челюсти в Ивантеевке:
                      точность и безопасность
                    </h3>
                    <p className="p-info">
                      Если вы задаетесь вопросом, как получить максимально
                      точное представление о состоянии своих зубов и челюсти, то
                      компьютерная томография (КТ) - это то, что вам нужно. В
                      стоматологии Dental Home мы предлагаем 3D компьютерную
                      томографию зубов, которая позволяет получить высокоточный
                      снимок полости рта.
                      <br /> <br />
                      КТ зубов - это современный метод диагностики, который
                      позволяет получить более подробную информацию, чем
                      рентген. Благодаря КТ, стоматолог может увидеть не только
                      зубы, но и кости, мягкие ткани и нервы. Это помогает более
                      точно определить причину болезней зубов и челюсти и
                      выбрать наиболее эффективное лечение.
                      <br />
                      <br />
                      Сделать КТ зубов в Ивантеевке можно в стоматологии Dental
                      Home. Наши специалисты используют современное
                      оборудование, которое обеспечивает высокую точность и
                      безопасность процедуры.
                    </p>
                  </div>
                  <div className="information-two mt-5">
                    <h3 className="heading-info">Как проходит КТ зубов?</h3>
                    <p className="p-info">
                      Компьютерная томография зубов - это безболезненная
                      процедура, которая занимает всего несколько минут. Во
                      время КТ пациенту необходимо находиться в специальном
                      аппарате, который делает серию рентгеновских снимков.
                      После этого компьютер обрабатывает полученные данные и
                      создает 3D модель полости рта.
                      <br /> <br />
                      КТ зубов - это современный метод диагностики, который
                      позволяет получить более подробную информацию, чем
                      рентген. Благодаря КТ, стоматолог может увидеть не только
                      зубы, но и кости, мягкие ткани и нервы. Это помогает более
                      точно определить причину болезней зубов и челюсти и
                      выбрать наиболее эффективное лечение.
                      <br />
                      <br />
                      КТ зубов - это безопасная процедура, которая не требует
                      особых подготовительных мер. Однако, если вы беременны или
                      подозреваете, что можете быть беременны, обязательно
                      сообщите об этом своему врачу перед процедурой.
                    </p>
                  </div>
                  <div className="information-two mt-5">
                    <h3 className="heading-info">Для чего нужна КТ зубов?</h3>
                    <p className="p-info">
                      Компьютерная томография зубов может использоваться для{" "}
                      {""}
                      {""}
                      <a href="https://dental-home.ru/services/diagnostic">
                        {""}
                        диагностики различных заболеваний {""}
                      </a>
                      {""}
                      и состояний полости рта, таких как:
                      <br /> <br />
                      - кариес;
                      <br />
                      <br />
                      - периодонтит;
                      <br />
                      <br />
                      - кисты;
                      <br />
                      <br />
                      - опухоли;
                      <br />
                      <br />
                      - травмы.
                      <br />
                      <br />
                      КТ зубов также может использоваться для планирования
                      имплантации зубов и других хирургических процедур.
                    </p>
                  </div>
                  <div className="information-two mt-5">
                    <h3 className="heading-info">
                      Записаться на КТ зубов в Ивантеевке
                    </h3>
                    <p className="p-info">
                      Если вы хотите сделать КТ зубов в Ивантеевке, то
                      записаться на прием в стоматологию Dental Home можно по
                      телефону или через онлайн-форму на нашем сайте. Наши
                      специалисты помогут вам подготовиться к процедуре и
                      ответят на все ваши вопросы.
                      <br /> <br />
                      Компьютерная томография зубов - это современный и
                      безопасный метод диагностики, который позволяет получить
                      максимально точное представление о состоянии зубов и
                      челюсти. Сделать КТ зубов в Ивантеевке можно в
                      стоматологии Dental Home, где вы получите
                      высококачественное лечение и заботливое отношение.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="gallery"
                id="works"
                style={{
                  borderTop: "1px solid #202637",
                  marginTop: "clamp(32px,3.33312vw,128px)",
                }}
              >
                <PcServiceGallery
                  imageSrc={serviceOnePc}
                  imageSrc2={serviceTwoPc}
                  imageSrc3={ServiceThreePc}
                  imageSrc4={ServiceFourPc}
                ></PcServiceGallery>
              </div>
              <div
                className="gallery"
                id="doctors"
                style={{
                  borderTop: "1px solid #202637",
                }}
              >
                <PcGallery />
                <div
                  className="gallery"
                  id="reviews"
                  style={{
                    borderTop: "1px solid #202637",
                    marginTop: "clamp(32px,3.33312vw,128px)",
                  }}
                >
                  <ReviewGalleryDesktop />
                </div>
                <div
                  className="form-pc-screen"
                  id="form-screen"
                  ref={form}
                  style={{ marginBottom: "clamp(64px,6.66624vw,256px)" }}
                  onSubmit={sendEmail}
                >
                  <section className="content">
                    <div className="heading-container">
                      <h5 className="heading">Записаться На Прием</h5>
                    </div>
                    <div className="divider"></div>
                    <form action="" className="form-content">
                      <div className="row-c">
                        <div className="input-container">
                          <span className="text">Имя*</span>
                          <input
                            type="text"
                            className="input-c"
                            required={true}
                            value={fullName}
                            name="fullName"
                            onChange={(event) =>
                              setFullName(event.target.value)
                            }
                            placeholder="Иван Иванов"
                          />
                        </div>
                        <div className="input-container">
                          <span className="text">Телефон*</span>
                          <input
                            type="text"
                            className="input-c"
                            required={true}
                            value={phoneNumber}
                            name="phoneNumber"
                            onChange={(event) =>
                              setPhoneNumber(event.target.value)
                            }
                            placeholder="+7 (925) 222-90-22"
                          />
                        </div>
                      </div>
                      <div className="row-c">
                        <div className="input-container services">
                          <span className="text">Услуга</span>
                          <input
                            type="text"
                            placeholder="Выберите Услугу"
                            required={true}
                            value={serviceName}
                            name="serviceName"
                            onChange={(event) =>
                              setServiceName(event.target.value)
                            }
                            className="input-s"
                          />
                        </div>
                      </div>
                      <div className="row-c"></div>
                      <div className="row-c">
                        <div className="input-container services">
                          <span className="text">Врач</span>
                          <input
                            type="text"
                            placeholder="Выберите Врача"
                            required={true}
                            value={doctorName}
                            name="doctorName"
                            onChange={(event) =>
                              setDoctorName(event.target.value)
                            }
                            className="input-s"
                          />
                        </div>
                      </div>
                      <div className="row-c">
                        <div className="input-container services">
                          <span className="text">Комментарий</span>
                          <textarea
                            className="comment"
                            name="comment"
                            value={comment}
                            onChange={(event) => setComment(event.target.value)}
                          />
                        </div>
                      </div>
                      <div className="checkbox-container">
                        <div className="check-row">
                          <input type="checkbox" className="checkbox" />
                          <span className="text">
                            Ознакомлен с Условиями обработки персональных данных
                          </span>
                        </div>
                        <button
                          className="golden-btn"
                          value="Send"
                          onClick={() => console.log(form)}
                        >
                          Записаться на прием
                          <FontAwesomeIcon
                            icon={faChevronRight}
                            className="icon"
                            style={{
                              fontSize: "clamp(6px,0.62496vw,24px)",
                              marginLeft: "clamp(4px,0.41664vw,16px)",
                            }}
                          ></FontAwesomeIcon>
                        </button>
                      </div>
                    </form>
                  </section>
                </div>
              </div>
            </div>
          </main>
          <Footer />
          <Popup
            open={open}
            closeOnDocumentClick
            onClose={closeModal}
            modal
            nested
            className="popup-container"
            position="center center"
          >
            <div className="modal">
              <img
                className="modal-img"
                src={modalImage}
                alt="modal-picture"
              ></img>
              <FontAwesomeIcon
                icon={faClose}
                onClick={closeModal}
                className="gold-cross"
              ></FontAwesomeIcon>
              <div className="modal-content">
                <img className="logo" src={logoMobile} alt="logotype"></img>
                <span className="text">Хотите получить консультацию?</span>
                <span className="additional-text">
                  Оставьте свой номер и мы перезвоним вам
                </span>
                <form className="input-container" onSubmit={sendPhoneRequest}>
                  <label htmlFor="phone-number-input" className="label">
                    Ваш номер телефона*
                  </label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    className="phone-number-input"
                    placeholder="+7 (925) 222-90-22"
                    required={true}
                    value={phoneNumber}
                    onChange={(event) => setPhoneNumber(event.target.value)}
                    style={{ textAlign: "center" }}
                    id=""
                  />
                  <button className="phone-btn" value="Send">
                    <FontAwesomeIcon
                      icon={faPhone}
                      className="icon"
                    ></FontAwesomeIcon>
                    Хорошо жду звонка
                  </button>
                </form>
              </div>
            </div>
          </Popup>
          <Popup
            open={thankYou}
            closeOnDocumentClick
            onClose={closeModal}
            modal
            nested
            className="popup-container"
            position="center center"
            overlayStyle={{ background: "rgba(0,0,0,0.7)" }}
          >
            <div className="modal-thanks">
              <FontAwesomeIcon
                icon={faClose}
                onClick={closeModal}
                className="gold-cross"
              ></FontAwesomeIcon>
              <div className="modl-content">
                <img className="logo" src={logoMobile} alt="logotype"></img>
                <span className="text">Спасибо за вашу заявку</span>
                <span className="additional-text">
                  В скором времени мы свяжемся с вами
                </span>
              </div>
            </div>
          </Popup>
        </div>
      )}
    </div>
  );
};

export default TeethCt;
